/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcOrdersV1BatchAllocationState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ORDERS_V1_BATCH_ALLOCATION_STATE_ENTITY_NAME = 'ixc.orders.v1.BatchAllocation';
export const ixcOrdersV1BatchAllocationStateEntity = new schema.Entity<IxcOrdersV1BatchAllocationState>(IXC_ORDERS_V1_BATCH_ALLOCATION_STATE_ENTITY_NAME, {}, { idAttribute: 'batchAllocationId' });

